import { BackgroundAnimationAsset } from '@shared/models/background-animation.model';

export enum BackgroundObjectFit {
  Cover = 'cover',
  Contain = 'contain',
}

export enum BackgroundAssetType {
  Image = 'image',
  Video = 'video',
  Animation = 'animation',
  None = 'none',
}

interface BackgroundMediaAsset {
  url: string;
  objectFit?: BackgroundObjectFit;
  objectPosition?: string;
}

export type BackgroundAsset =
  | ({ type: BackgroundAssetType.Image } & BackgroundMediaAsset)
  | ({ type: BackgroundAssetType.Video } & BackgroundMediaAsset)
  | { type: BackgroundAssetType.Animation; animation: BackgroundAnimationAsset }
  | { type: BackgroundAssetType.None };

export const NONE_BACKGROUND_ASSET: BackgroundAsset = {
  type: BackgroundAssetType.None,
};
